// Validate that required environment variables are defined
const validateEnvVar = (value: string | undefined, name: string): string => {
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
};

export const API_URL: string = validateEnvVar(
  process.env.REACT_APP_BACKEND_FUNCTION_URL,
  'REACT_APP_BACKEND_FUNCTION_URL'
);

export const CLIENT_ID: string = validateEnvVar(
  process.env.REACT_APP_B2C_CLIENT_ID,
  'REACT_APP_B2C_CLIENT_ID'
);

export const REDIRECT_URI: string = validateEnvVar(
  process.env.REACT_APP_B2C_REDIRECT_URI,
  'REACT_APP_B2C_REDIRECT_URI'
);

export const TENANT_NAME: string = validateEnvVar(
  process.env.REACT_APP_B2C_TENANT_NAME,
  'REACT_APP_B2C_TENANT_NAME'
);